import { useEffect, useState } from 'react';
import { PositionX, useDeviceSize } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { Languages, languagesObject } from '../../providers';
import { RoutesName } from '../../states';
import {
  ButtonLanguage,
  OptionMenuHeader,
  OptionMenuItemHeader,
  LanguageMenuWrapper,
} from './Styles';

export const LanguageSelection = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isMobile } = useDeviceSize();

  const changeLanguageHandler = (language: Languages) => {
    i18n.changeLanguage(language);
  };

  const formatLanguage = i18n?.language?.split('-')[0] || Languages.en;
  const isGdprMobile =
    isMobile && window.location.pathname === RoutesName.terms;

  useEffect(() => {
    const targetNode: Node | null = document.getElementById('popup-root');
    const config = { attributes: false, childList: true, subtree: false };

    const callback = (mutationList: MutationRecord[]) => {
      for (const mutation of mutationList) {
        setIsOpen(Boolean(mutation.addedNodes.length));
      }
    };

    const observer = new MutationObserver(callback);
    targetNode && observer.observe(targetNode, config);

    return () => observer.disconnect();
  }, []);

  return (
    <LanguageMenuWrapper
      flexDirection="row"
      justifyContent="flex-end"
      $asLayout={isGdprMobile}
    >
      <OptionMenuHeader
        language
        $isOpen={isOpen}
        isMobile={isMobile}
        testId="change-language"
        positionX={PositionX.right}
        hidePanelOnClick={true}
        renderItem={
          <ButtonLanguage
            flexDirection="row-reverse"
            columnGap="1"
            alignItems="center"
            forwardedAs="button"
            $isOpen={isOpen}
          >
            <span>{formatLanguage}</span>
            {languagesObject[formatLanguage as Languages]}
          </ButtonLanguage>
        }
      >
        {Object.entries(languagesObject)
          .filter(([value]) => value !== formatLanguage)
          .map(([value, flag]) => (
            <OptionMenuItemHeader
              color="white"
              key={value}
              onClick={() => changeLanguageHandler(value as Languages)}
            >
              {flag}
              <span>{value}</span>
            </OptionMenuItemHeader>
          ))}
      </OptionMenuHeader>
    </LanguageMenuWrapper>
  );
};
